import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Evolution Game 🧬</h1>
        <p>Evolution Game is a life simulation where a user can control the DNA parameters and observe how their artificial colonies are developing and fighting for survival for the sake of energy. The goal is to recreate detailed living conditions, including energy, day/night, mortality from lack of it, soil, environment, collaboration, etc. The user has the ability to manage parameters of the living sectors (such as border width, size of arena, among families, output folder) and life cells (DNA) by varying sliders and inputs on a side of the GUI window. At the end of the simulation, each iteration is combined to form a video provided to a user to observe the evolution of cells in real-time. </p>
        <div className='links'>
          <a className='button' href="https://drive.google.com/file/d/1MNWzuE-PL67Z0QaQo20pIsoSCDv9V-Jj/view?usp=sharing" download>Download App</a>
          <a href="https://github.com/anton-mel/CellEvolution">OpenSource Code</a>
        </div>
        <div className='version'>
          <p>Developed by: @anton-mel</p>
          <p>Latest Version: v.1.0</p>
        </div>
      </header>
    </div>
  );
}

export default App;
